import React, { useContext, useRef } from 'react';
import Title from '../resources/Title';
import { MainContext } from '../../context/MainContext'
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { DataGrid } from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import * as Constants from '../api/constants'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FormGroup, FormControlLabel, Checkbox, Button, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

function createData(id, email, firstName, lastName, spaName, macAddress, version, firmwareVersion, isOnline, signalStrength, serverNumber, mqttStatus, deleteSpa) {
  return { id, email, firstName, lastName, spaName, macAddress, version, firmwareVersion, isOnline, signalStrength, serverNumber, mqttStatus, deleteSpa };
}

let rows = [];

const cellRenderer = (params) => {
  return params.value;
};

export default function SpaList(props) {
  const { spas, spasCount } = useContext(MainContext);
  const parent = props;
  const [open, setOpen] = React.useState(false);
  const [openFilter, setFilterOpen] = React.useState(false);
  const [macAddress, setMacAddress] = React.useState(rows);
  const [spaId, setSpaId] = React.useState(0);
  const [page, setPage] = React.useState(0);
  const [sortModel, setSortModel] = React.useState([
    { field: "id", sort: "asc" }
  ])

  const [filters, setFilters] = React.useState({
    MQTT: false,
    SmartSignal: false
  });

  const [tempFilters, setTempFilters] = React.useState({
    MQTT: false,
    SmartSignal: false,
  });

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setTempFilters((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleSetFilter = () => {
    setFilters(tempFilters);
    setSpinner(true);
    handleSearch(tempFilters);
    handleFilterClose();
  };

  const handleFilterOpen = () => setFilterOpen(true);

  const handleFilterClose = () => setFilterOpen(false);

  const selectedFilterCount = Object.values(filters).filter(Boolean).length;

  function alphaNumSpecialComparator(v1, v2) {
    const getGroup = (s) => {
      if (!s) return 3;
      const c = s[0];
      if (/[a-zA-Z]/.test(c)) return 0;
      if (/[0-9]/.test(c)) return 1;
      return 2;
    };

    const g1 = getGroup(v1);
    const g2 = getGroup(v2);

    if (g1 !== g2) return g1 - g2;

    return (v1 || "").localeCompare(v2 || "");
  }

  let columns = [
    { field: 'id', headerName: 'ID', minWidth: 40 },
    { field: 'email', headerName: 'Email', flex: 2, minWidth: 250 },
    { field: 'firstName', headerName: 'First Name', flex: 1, minWidth: 120, sortComparator: alphaNumSpecialComparator },
    { field: 'lastName', headerName: 'Last Name', flex: 1, minWidth: 120, sortComparator: alphaNumSpecialComparator },
    { field: 'spaName', headerName: 'Spa Name', flex: 1, minWidth: 120 },
    { field: 'macAddress', headerName: 'MAC Address', flex: 1, minWidth: 150 },
    { field: 'version', headerName: 'Version', flex: 1, minWidth: 100 },
    { field: 'firmwareVersion', headerName: 'Firmware', flex: 1, minWidth: 100 },
    { field: 'isOnline', headerName: 'Online', flex: 1, minWidth: 100 },
    { field: 'signalStrength', headerName: 'RSSI', flex: 1, minWidth: 100 },
    { field: 'serverNumber', headerName: 'Server', flex: 1, minWidth: 100 },
    { field: 'mqttStatus', headerName: 'MQTT Status', flex: 1, minWidth: 100 },
    { field: 'deleteSpa', headerName: 'Delete', flex: 1, minWidth: 100, renderCell: cellRenderer, sortable: false, disableColumnMenu: true },
  ];

  rows = [];

  const tfName = useRef('');
  const tfEmail = useRef('');
  const tfMacAddress = useRef('');
  const tfSpaName = useRef('');

  const [spinner, setSpinner] = React.useState(true);

  const [data, setData] = React.useState(rows);
  React.useEffect(() => {
    if (spas === undefined) return;

    [...spas].forEach(element => {
      rows.push(createData(element.id,
        element.email,
        element.firstName,
        element.lastName,
        element.spaName,
        element.macAddress,
        element.version,
        element.firmwareVersion,
        element.isOnline ? 'Online' : 'Offline',
        element.signalStrength + ' dB',
        element.serverNumber,
        element.mqttStatus,
        <Button variant="contained" color="error" type="submit" onClick={() => { handleDeleteClickOpen(element.id, element.macAddress) }}>Delete</Button>))
    });

    setData(rows)
    setSpinner(false);
  }, [spas])

  React.useEffect(() => {
    const s = sortModel?.[0] ?? { field: "id", sort: "asc" };
    parent.getSpasList(
      '',
      '',
      '',
      '',
      false,
      false,
      page,
      s.field,
      s.sort);
  }, [page, sortModel]);

  const handleSearch = (appliedFilters = filters) => {
    setSpinner(true);
    parent.clearSpaList();
    parent.getSpasList(
      tfName.current.value,
      tfEmail.current.value,
      tfMacAddress.current.value,
      tfSpaName.current.value,
      appliedFilters.MQTT,
      appliedFilters.SmartSignal
    );
  };

  const onChangeHandler = (ev) => {
    if (tfName.current.value === '' && tfEmail.current.value === '' && tfMacAddress.current.value === '' && tfSpaName.current.value === '' &&
      ev.key !== 'Enter') {
      parent.getSpasList(tfName.current.value, tfEmail.current.value, tfMacAddress.current.value, tfSpaName.current.value);
    }
  }

  const handleDeleteClickOpen = (id, macAddress) => {
    setSpaId(id);
    setMacAddress(macAddress);
    setOpen(true);
  };
  const handleDeleteCloseDialog = () => {
    setOpen(false);
  }

  const handleDeleteClose = () => {
    setOpen(false);

    const requestOptions = {
      method: 'DELETE',
      credentials: "include"
    };

    const parameters = new URLSearchParams({
      id: spaId,
      macAddress: macAddress,
    });

    fetch(Constants.baseURL + Constants.apiDeleteSpa + '?' + parameters, requestOptions)
      .then(response => {
        if (!response.ok && response.status !== 404) {
          this.props.history.push('/');
        }

        if (response.ok) {
          parent.getSpasList();
          toast.success('Spa deleted successfully', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.error('Error. Please try again', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch(error => { console.log('request failed', error); });
  };

  return (
    <React.Fragment>
      <ToastContainer />

      <Grid
        container
        spacing={1}
        alignItems="center"
        sx={{
          mb: 1,
          flexWrap: { xs: "wrap", sm: "nowrap" },
          justifyContent: { xs: "flex-start", sm: "flex-end" },
          "& .MuiGrid-item": { minWidth: 0, maxWidth: 250 },
        }}
      >
        <Grid
          item
          xs={12}
          sm="auto"
          sx={{
            whiteSpace: "nowrap",
            mr: { xs: 0, sm: "auto" },
          }}
        >
          <Title>Spas</Title>
        </Grid>

        <Grid item xs={12} sm>
          <TextField
            id="tfSpaName"
            inputRef={tfSpaName}
            label="Spa Name"
            size="small"
            fullWidth
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            onChange={onChangeHandler}
          />
        </Grid>

        <Grid item xs={12} sm>
          <TextField
            id="tfName"
            inputRef={tfName}
            label="Name"
            size="small"
            fullWidth
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            onChange={onChangeHandler}
          />
        </Grid>

        <Grid item xs={12} sm>
          <TextField
            id="tfEmail"
            inputRef={tfEmail}
            label="Email"
            size="small"
            fullWidth
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            onChange={onChangeHandler}
          />
        </Grid>

        <Grid item xs={12} sm>
          <TextField
            id="tfMacAddress"
            inputRef={tfMacAddress}
            label="MAC Address"
            size="small"
            fullWidth
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            onChange={onChangeHandler}
          />
        </Grid>

        <Grid item xs={12} sm="auto">
          <Button variant="contained" type="button" onClick={handleFilterOpen}>
            Filter{selectedFilterCount > 0 ? ` (${selectedFilterCount})` : ''}
          </Button>
        </Grid>

        <Grid item xs={12} sm="auto">
          <Button variant="contained" type="submit" onClick={handleSearch}>
            Search
          </Button>
        </Grid>

      </Grid>

      <div style={{ height: 641, width: '100%', 'padding-top': '10px' }}>
        <DataGrid sx={{
          "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
            outline: "none !important",
          },
          "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within": {
            outline: "none !important",
          },
        }}
          sortingOrder={["asc", "desc"]}
          rows={data}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[5]}
          checkboxSelection={false}
          isRowSelectable={false}
          disableSelectionOnClick
          loading={spinner}
        />
        <Dialog
          open={open}
          keepMounted
          onClose={handleDeleteCloseDialog}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>{"Delete Spa"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Are you sure you want to delete this spa: {macAddress}?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteCloseDialog}>No</Button>
            <Button onClick={handleDeleteClose}>Yes</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openFilter} onClose={handleFilterClose} >
          <DialogTitle>Filter Options</DialogTitle>
          <DialogContent>
            <DialogContentText>Select options to filter your search:</DialogContentText>

            <FormGroup>
              {Object.keys(tempFilters).map((key) => (
                <FormControlLabel
                  key={key}
                  control={
                    <Checkbox
                      name={key}
                      checked={tempFilters[key]}
                      onChange={handleCheckboxChange}
                    />
                  }
                  label={key}
                />
              ))}
            </FormGroup>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleFilterClose}>Close</Button>
            <Button onClick={handleSetFilter}>Filter</Button>
          </DialogActions>
        </Dialog>
      </div>
    </React.Fragment>
  );
}